import React, { useEffect, useState, useRef } from 'react';
import {
    useLocation,
    Link,
} from "react-router-dom";
import axios from 'axios';
import Minibar from '../../../components/navbar/Minibar.js';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import CanvasJSReact_ChartPerformance from '../../../components/chart/ChartPerformanceBusiness.js';
import moment from 'moment'
import './Overall.css'
import MapPin from '../../../components/map_pin/MapPin.js';
import {
    commonlibs_getfirstplot_mode
} from '../../ComLibrary.js';

function Business(props) {
    let ismount = useRef(true);
    let isfetch = useRef(false);
    let isfirst = useRef(true);

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const location = useLocation();
    const hot_update = useRef('-')
    const [page_selected, setPage_selected] = useState(1);
    const group_ref = useRef('')
    const [group_selected, setGroup_selected] = useState('-');
    const [server_update, setServerUpdate] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"))
    const [dashboard_tabs, setDashboard_tabs] = useState('energy');
    const [display_mode, setDisplay_mode] = useState(commonlibs_getfirstplot_mode(0));
    const [submenu_root, setSubmenu_root] = useState('Overall');
    const [map_option, setMap_option] = useState('-');
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const [map_pin_filtered, setMap_pin_filtered] = useState([])
    const [map_pin, setMap_pin] = useState([])
    const [plot_color, setPlot_color] = useState([])
    const [site_handle, setSite_handle] = useState([])
    const [summary_table, setSummary_table] = useState([])
    const [chart_daily, setChart_daily] = useState({})
    const [chart_monthly, setChart_monthly] = useState({})
    const [chart_yearly, setChart_yearly] = useState({})
    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        Energy: [],
        PR: [],
        PRG: [],
        ORx: [],
        ORG: [],
        ENS: [],
        Saving: [],
        Value: [],
        CO2: [],
        CODData: null,
        Chart1_Style: { height: 235, unit: "kWh", digit: 3, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart2_Style: { height: 235, unit: "%", digit: 2, type: "line", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart3_Style: { height: 235, unit: "%", digit: 2, type: "line", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart4_Style: { height: 235, unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart5_Style: { height: 235, unit: "kg", digit: 3, type: "column", axis_y1: 'CO2 Reduction (kg)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart6_Style: { height: 235, unit: "THB", digit: 3, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart7_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
        summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
        co2_factor: [],
        sum_time: [],
        chart_box: []
    });

    useEffect(() => {
        if (location.pathname.includes("dbgroup/Feed")) {
            group_ref.current = "Feed"
        } else if (location.pathname.includes("dbgroup/Farm")) {
            group_ref.current = "Farm"
        } else if (location.pathname.includes("dbgroup/Food")) {
            group_ref.current = "Food"
        } else if (location.pathname.includes("dbgroup/Other")) {
            group_ref.current = "Other"
        }
        setGroup_selected(group_ref.current)
    }, [location]);

    useEffect(() => {
        if (map_option === "-") {
            setMap_pin_filtered(map_pin)
        } else if (map_option === "alarm") {
            const result = map_pin.filter((item) => item.alert_class === ' alarming' || item.alert_class === ' warning');
            setMap_pin_filtered(result)
        }
    }, [map_option, map_pin]);

    useEffect(() => {
        if (group_selected == "Farm" || group_selected == "Food" || group_selected == "Feed" || group_selected == "Other") {
            ismount.current = true
            isfirst.current = true
            hot_update.current = "-"
            setPage_selected(1)
            setChart_daily({})
            setChart_monthly({})
            setChart_yearly({})
            setSummary_table([])
            setSite_handle([])
            setMap_pin([])
            setPlot_color([])
            if (!isfetch.current) {
                api_get_dashboard()
            }
        }
    }, [group_selected]);

    useEffect(() => {
        if (!isfetch.current) {
            api_get_dashboard()
        }
    }, [props.center_hot_update]);

    useEffect(() => {
        return () => {
            ismount.current = false
            setChart_plot({
                XLabel: '',
                Energy: [],
                PR: [],
                PRG: [],
                ORx: [],
                ORG: [],
                ENS: [],
                Saving: [],
                Value: [],
                CO2: [],
                CODData: null,
                Chart1_Style: { height: 235, unit: "kWh", digit: 3, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                Chart2_Style: { height: 235, unit: "%", digit: 2, type: "line", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                Chart3_Style: { height: 235, unit: "%", digit: 2, type: "line", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                Chart4_Style: { height: 235, unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                Chart5_Style: { height: 235, unit: "kg", digit: 3, type: "column", axis_y1: 'CO2 Reduction (kg)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                Chart6_Style: { height: 235, unit: "THB", digit: 3, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                Chart7_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
                summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
                summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
                co2_factor: [],
                sum_time: [],
                chart_box: []
            })
            setChart_daily({})
            setChart_monthly({})
            setChart_yearly({})
            setSummary_table([])
            setSite_handle([])
            setMap_pin([])
            setPlot_color([])
        };
    }, []);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        var daplot = {
            XLabel: 'ccc',
            Energy: [],
            PR: [],
            PRG: [],
            ORx: [],
            ORG: [],
            ENS: [],
            Saving: [],
            Value: [],
            CO2: [],
            CODData: null,
            Chart1_Style: {},
            Chart2_Style: {},
            Chart3_Style: {},
            Chart4_Style: {},
            Chart5_Style: {},
            Chart6_Style: {},
            Chart7_Style: {},
            co2_factor: [],
            sum_time: [],
            chart_box: []
        }
        var demo_chart
        if (display_mode === "Daily") {
            demo_chart = chart_daily
            daplot.Chart1_Style = { height: 235, unit: "kWh", digit: 2, type: "stackedColumn", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "kWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart5_Style = { height: 235, unit: "kgCO<sub>2</sub>", digit: 3, type: "stackedColumn", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.CODData = null
        } else if (display_mode === "Monthly") {
            demo_chart = chart_monthly
            daplot.Chart1_Style = { height: 235, unit: "kWh", digit: 2, type: "stackedColumn", axis_y1: 'Solar Energy (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "kWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart5_Style = { height: 235, unit: "kgCO<sub>2</sub>", digit: 3, type: "stackedColumn", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
        } else if (display_mode === "Yearly") {
            demo_chart = chart_yearly
            daplot.Chart1_Style = { height: 235, unit: "MWh", digit: 3, type: "stackedColumn", axis_y1: 'Solar Energy (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "MWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart5_Style = { height: 235, unit: "TonCO<sub>2</sub>", digit: 3, type: "stackedColumn", axis_y1: 'CO2 Reduction (TonCO2)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.,.M', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.,.M', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            //  daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
        }
        if (demo_chart.chart !== null && demo_chart.chart !== undefined) {
            var lock = false
            daplot.XLabel = demo_chart.xlabel
            daplot.sum_time = demo_chart.sum_time
            daplot.chart_box = demo_chart.chart_box
            daplot.co2_factor = demo_chart.factor_co2
            for (let gp = 0; gp < demo_chart.chart.length; gp++) {
                daplot.Energy.push([])
                daplot.PR.push([])
                daplot.ORx.push([])
                daplot.ENS.push([])
                daplot.Saving.push([])
                daplot.Value.push([])
                daplot.CO2.push([])
                if (demo_chart.chart[gp] !== null && demo_chart.chart[gp] !== undefined) {
                    if (!lock) {
                        daplot.Chart2_Style.start = new Date(demo_chart.chart[gp][0].x)
                        daplot.Chart3_Style.start = new Date(demo_chart.chart[gp][0].x)
                        lock = true
                    }
                    daplot.PRG = []
                    daplot.ORG = []
                    for (let i = 0; i < demo_chart.chart[gp].length; i++) {
                        const dx = new Date(demo_chart.chart[gp][i].x)

                        const tm1_energy = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['solar'],
                        }
                        const tm_pr = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['pr_ens']
                        }
                        const tm_prg = {
                            x: dx,
                            y: daplot.sum_time[i]['PRG']
                        }
                        const tm_or = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['orx_ens']
                        }
                        const tm_org = {
                            x: dx,
                            y: daplot.sum_time[i]['ORG']
                        }
                        const tm_ens = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['ens']
                        }
                        const tm_save = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['saving']
                        }
                        const tm_value = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['value']
                        }
                        const tm_co2 = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['co2']
                        }
                        daplot.Energy[gp].push(tm1_energy)
                        daplot.PR[gp].push(tm_pr)
                        daplot.PRG.push(tm_prg)
                        daplot.ORx[gp].push(tm_or)
                        daplot.ORG.push(tm_org)
                        daplot.ENS[gp].push(tm_ens)
                        daplot.Saving[gp].push(tm_save)
                        daplot.Value[gp].push(tm_value)
                        daplot.CO2[gp].push(tm_co2)
                    }
                }
            }

            setChart_plot({
                ...chart_plot,
                XLabel: daplot.XLabel,
                Energy: daplot.Energy,
                PR: daplot.PR,
                PRG: daplot.PRG,
                ORx: daplot.ORx,
                ORG: daplot.ORG,
                ENS: daplot.ENS,
                Saving: daplot.Saving,
                Value: daplot.Value,
                CO2: daplot.CO2,
                CODData: daplot.CODData,
                Chart1_Style: daplot.Chart1_Style,
                Chart2_Style: daplot.Chart2_Style,
                Chart3_Style: daplot.Chart3_Style,
                Chart4_Style: daplot.Chart4_Style,
                Chart5_Style: daplot.Chart5_Style,
                Chart6_Style: daplot.Chart6_Style,
                Chart7_Style: daplot.Chart7_Style,
                summary: {
                    Energy: demo_chart.sum_total.Energy,
                    PRx: demo_chart.sum_total.PR,
                    ORx: demo_chart.sum_total.ORx,
                    ENS: demo_chart.sum_total.ENS,
                    Saving: demo_chart.sum_total.Saving,
                    Value: demo_chart.sum_total.Value,
                    CO2: demo_chart.sum_total.CO2,
                },
                summary_unit: {
                    Energy: getUnit(demo_chart.sum_unit, 'sum_energy'),
                    PRx: getUnit(demo_chart.sum_unit, 'pr_ens'),
                    ORx: getUnit(demo_chart.sum_unit, 'orx_ens'),
                    ENS: getUnit(demo_chart.sum_unit, 'sum_ens'),
                    Saving: getUnit(demo_chart.sum_unit, 'sum_saving'),
                    Value: getUnit(demo_chart.sum_unit, 'sum_value'),
                    CO2: getUnit(demo_chart.sum_unit, 'sum_co2'),
                },
                co2_factor: daplot.co2_factor,
                sum_time: daplot.sum_time,
                chart_box: daplot.chart_box
            })
        }
    }, [display_mode, chart_daily, chart_monthly, chart_yearly]);

    function getUnit(data, tag) {
        if (data !== null) {
            return data[tag]
        }
        return ""
    }

    async function api_get_dashboard() {
        if (isfirst.current) {
            //setmodal_load({ enable: true, message: "Loading business dashboard data.." })
        }
        isfetch.current = true
        const formData = new FormData()
        formData.append('sitelist', props.permitdata.sitescope_str)
        formData.append('update_key', hot_update.current)
        formData.append('group', group_ref.current)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/dashboard/business", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer LBV976sR1GpcM9YZUWPjCev7gs8hVO60pcCsUeyeyz1fxo7cXOEJKS12dDMjhJDz"
            },
        })
            .then((response) => {
                isfetch.current = false
                isfirst.current = false
                setmodal_load({ enable: false, message: "" })
                if (ismount.current) {
                    if (response.data.status === 'OK' && response.data.group_selected !== undefined) {
                        if (group_ref.current === response.data.group_selected) {
                            if (response.data.map_pin_list !== undefined) {
                                setMap_pin(response.data.map_pin_list)
                            }
                            if (response.data.summary_table !== undefined) {
                                setSummary_table(response.data.summary_table)
                            }
                            if (response.data.site_handle !== undefined) {
                                setSite_handle(response.data.site_handle)
                            }

                            if (response.data.data_day !== undefined) {
                                setChart_daily(response.data.data_day)
                            }
                            if (response.data.data_month !== undefined) {
                                setChart_monthly(response.data.data_month)
                            }
                            if (response.data.data_year !== undefined) {
                                setChart_yearly(response.data.data_year)
                            }
                            if (response.data.update_key !== undefined) {
                                hot_update.current = response.data.update_key
                                setServerUpdate(response.data.update_key)
                            }
                            if (response.data.plot_color !== undefined) {
                                setPlot_color(response.data.plot_color)
                            }
                        }
                    }
                    else {

                    }
                }
            })
            .catch((err) => {
                isfetch.current = false
                isfirst.current = false
                setmodal_load({ enable: false, message: "" })
            });
    }

    function gettable_flags(alarm, classx, isonlin) {
        if (alarm !== "") {
            return <span className={'border-black me-1 dashboard-tagalarm2 ' + classx}  >{alarm}</span>
        }
        if (isonlin !== undefined) {
            return <span className='border-black me-1 dashboard-tagalarm2 normal'  >ONLINE</span>
        }
        return null
    }

    function page_back() {
        var max_page = Math.ceil((summary_table.length - 1) / 5)
        if (page_selected > 1) {
            setPage_selected(page_selected - 1)
        }
    }

    function page_next() {
        var max_page = Math.ceil((summary_table.length - 1) / 5)
        if (page_selected < max_page) {
            setPage_selected(page_selected + 1)
        }
    }

    function getTotalWord(tags) {
        if (summary_table.length > 6) {
            return <><i className='fas fa-angle-double-right'></i> {tags}  {" (" + (summary_table.length - 1) + " Sites)"}</>
        }
        return <><i className='fas fa-angle-double-right'></i> {tags}</>
    }

    async function api_check_online(sitecode, sitename_th) {
        setmodal_load({ enable: true, message: "Connecting to " + sitecode + " " + sitename_th })
        await sleep(500)
        return new Promise((resolve, reject) => {
            const formData = new FormData()
            axios.post(process.env.REACT_APP_API_URL + "/proxy/local/" + sitecode + "/api/authentication/plantinfo", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
                },
            })
                .then((response) => {
                    if (ismount.current) {
                        setmodal_load({ enable: false, message: "" })
                        if (response.data.status === 'OK') {
                            resolve(true)
                        }
                        else {
                            resolve(false)
                        }
                    }
                    resolve(false)
                })
                .catch((err) => {
                    if (ismount.current) {
                        setmodal_load({ enable: false, message: "" })
                        resolve(false)
                    }
                });
        })
    }

    async function check_site(sitecode, sitename_en, sitename_th, api_url) {
        var state = await api_check_online(sitecode, sitename_th)
        if (state) {
            props.callback_select_site(sitecode, sitename_en, sitename_th, api_url, "/appcenter/dashboard/dbgroup/" + group_ref.current)
        } else {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Site Access Problem',
                message: 'Sorry! Can not access to local site at this time, it\'s seem like connection between central and local has been lose. \r\nPlease try again or contact your system administrator.',
                enable: true
            });
        }
    }

    function gotosite(data) {
        check_site(data.sitecode_text,
            data.sitename_en,
            data.sitename_th,
            "/proxy/local/" + data.sitecode_text)
    }

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Realtime Dashboard"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0 hi-100 border-left">
                    <div id="page-content">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="row mb-2">
                                    <div className="col-xl-12">
                                        <h4 className="mb-1"><i className="mdi mdi-monitor-dashboard"></i> {group_selected} Business Dashboard</h4>
                                        <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {moment(new Date(server_update)).format("YYYY-MM-DD HH:mm:ss")}</h6>
                                        <hr className="new-section-xs mb-2" />
                                    </div>
                                </div>

                                <div className="overall-ui d-block d-xxl-flex">
                                    <div className='mapx-box d-none d-xxl-block'>
                                        <div className='d-block d-md-flex justify-content-md-between w-100 card-overall-chart-header pb-1'>
                                            <div className='card-overall-header-wrapper'><h6><i className="mdi mdi-map-marker-circle"></i> Sites Map Indicator</h6></div>
                                            <div>
                                                <select name="status" className="form-select custom" value={map_option} style={{ cursor: "pointer" }} onChange={(e) => {
                                                    setMap_option(e.target.value)
                                                }} required>
                                                    <option value={"-"}>All Sites</option>
                                                    <option value={"alarm"}>Only Alarm</option>
                                                </select>
                                            </div>
                                        </div>
                                        <h6 className='mt-1 mb-0'>Noted :</h6>
                                        <h6 className='font-address mt-0'>Map marker flashing means an alarm has been occurring on local sites or communication between the center and local sites has been disconnected.</h6>
                                        <div className='mapx-wrapper'>
                                            <img src="/images/map_23062025_0211.png"></img>
                                            {
                                                map_pin_filtered?.map((data, index) => (
                                                    <MapPin marker={data} key={data.sitecode_text}></MapPin>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className='chart-area'>
                                        <div className="card card-common card-overall1">
                                            <div className="card-body pb-3">
                                                <div className='d-block d-md-flex justify-content-md-between w-100 card-overall-chart-header pb-1'>
                                                    <div className='card-overall-header-wrapper'>
                                                        <h6><i className='mdi mdi-table-large'></i> {group_selected} Business Summary Table</h6>
                                                        {/* <h6 className='card-overall-header-subtitle'>Data of current day are included in month, year and total.</h6> */}
                                                    </div>
                                                    <div className='justify-content-start d-flex gap-1 '>
                                                        <Link className='btn-chart-small ' to="/appcenter/dashboard/dboverall" style={{ minWidth: "45px" }}><i className='mdi mdi-keyboard-backspace'></i> Back to Overall</Link>
                                                        <div className={'d-flex gap-1 ' + (summary_table.length > 6 ? "" : "d-none")}>
                                                            <button className='btn-chart-small ' onClick={() => { page_back() }} style={{ minWidth: "45px" }}> {" < Prev"} </button>
                                                            <button className='btn-chart-small ' onClick={() => { page_next() }} style={{ minWidth: "45px" }}> {" Next >"} </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='dashboard-table-wrapper'>
                                                    <table className='text-dark'>
                                                        <thead>
                                                            <tr>
                                                                <th rowSpan={2} className='border-bottom-dashboard bussiness-column'>Site Name</th>
                                                                <th className='text-right'>Capacity</th>
                                                                <th className='text-right'>Today</th>
                                                                <th className='text-right'>Total</th>
                                                                <th className='text-right'>EST. Value</th>
                                                                <th className='text-right'>EST. Save</th>
                                                                <th className='text-right'>Area</th>
                                                                <th className='text-center' style={{ minWidth: "100px", maxWidth: "100px" }}></th>
                                                            </tr>
                                                            <tr>
                                                                <th className='text-right'>kWp</th>
                                                                <th className='text-right'>kWh</th>
                                                                <th className='text-right'>GWh</th>
                                                                <th className='text-right'>MTHB</th>
                                                                <th className='text-right'>MTHB</th>
                                                                <th className='text-right'>m<sup>2</sup></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                summary_table?.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    data.name !== "Total" ?
                                                                                        <div className='table-dashboard-icon-wrapper' key={data.sitecode_text}>
                                                                                            <div className='table-dashboard-icon' style={{ backgroundColor: data.color }}>{data.sitecode_no}</div>
                                                                                            <div>
                                                                                                <h6 className='me-1 font-sarabun font-factory text-dark'>{data.sitename_th}</h6>
                                                                                                <h6 className='font-sarabun font-address'>{data.siteaddress_sm}</h6>
                                                                                            </div>
                                                                                            {gettable_flags(data.count_offline, "alarming", true)} {gettable_flags(data.count_alarm, "alarming")} {gettable_flags(data.count_warning, "warning")}
                                                                                        </div>
                                                                                        :
                                                                                        getTotalWord(data.business)
                                                                                }
                                                                            </td>
                                                                            <td className='text-right'>{data.capacity}</td>
                                                                            <td className='text-right'>{data.today}</td>
                                                                            <td className='text-right'>{data.total}</td>
                                                                            <td className='text-right'>{data.est_value}</td>
                                                                            <td className='text-right'>{data.est_save}</td>
                                                                            <td className='text-right font-bold'>{data.area}</td>
                                                                            <td className='text-right' width={"40px"}>
                                                                                {data.name !== "Total" ?
                                                                                    <div className='btn-chart-small bg-blue text-white'
                                                                                        onClick={() => { gotosite(data) }}>Site ACCESS</div>
                                                                                    : null}
                                                                            </td>
                                                                        </tr>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card card-common card-overall2">
                                            <div className="card-body pb-3">
                                                <div className='d-block d-md-flex justify-content-md-between w-100 card-overall-chart-header pb-1'>
                                                    <div className='card-overall-header-wrapper mb-1 mb-md-0'>
                                                        <h6><i className="mdi mdi-chart-line"></i> {group_selected} Business Chart</h6>
                                                        <h6 className='card-overall-header-subtitle'>Data of current day are not included in monthly and yearly charts.</h6>
                                                    </div>
                                                    <div className='justify-content-start d-flex gap-1' >
                                                        <button className={'btn-chart-small ' + (display_mode === "Daily" ? "bg-blue text-white" : "")} onClick={() => { setDisplay_mode("Daily") }}>Daily</button>
                                                        <button className={'btn-chart-small ' + (display_mode === "Monthly" ? "bg-blue text-white" : "")} onClick={() => { setDisplay_mode("Monthly") }}>Monthly</button>
                                                        <button className={'btn-chart-small ' + (display_mode === "Yearly" ? "bg-blue text-white" : "")} onClick={() => { setDisplay_mode("Yearly") }}>Yearly</button>
                                                    </div>
                                                </div>
                                                <div className='d-block d-md-flex justify-content-md-end w-100 ' style={{ border: "none" }}>
                                                    <div className={'justify-content-start d-flex gap-1 mt-1 pb-1 ' + (summary_table.length > 6 ? " " : " d-none")}>
                                                        <button className='btn-chart-small ' onClick={() => { page_back() }} style={{ minWidth: "45px" }}> {" < Prev"} </button>
                                                        <button className='btn-chart-small ' onClick={() => { page_next() }} style={{ minWidth: "45px" }}> {" Next >"} </button>
                                                    </div>
                                                </div>
                                                <div className="toolbar-end px-2 mb-4 mt-1">
                                                    <ul className="nav nav-tabs card-header-tabs">
                                                        <li className="nav-item">
                                                            <Link className={"nav-link" + (dashboard_tabs === "energy" ? " show active" : "")} onClick={() => { setDashboard_tabs("energy") }}>Energy & Performance</Link>
                                                        </li>
                                                        <li className="nav-item">
                                                            <Link className={"nav-link" + (dashboard_tabs === "operation" ? " show active" : "")} onClick={() => { setDashboard_tabs("operation") }} >Operation & ENS</Link>
                                                        </li>
                                                        <li className="nav-item">
                                                            <Link className={"nav-link" + (dashboard_tabs === "co2" ? " show active" : "")} onClick={() => { setDashboard_tabs("co2") }}>CO2 & Saving</Link>
                                                        </li>
                                                        <li className="nav-item">
                                                            <Link className={"nav-link" + (dashboard_tabs === "value" ? " show active" : "")} onClick={() => { setDashboard_tabs("value") }}>Energy Value</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className={'tabs-content' + (dashboard_tabs === "energy" ? " " : " d-none")}>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">Solar Energy</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.Energy}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_energy}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.Energy}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_energy}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'Energy'}
                                                            plotdata={chart_plot.Energy}
                                                            chart_style={chart_plot.Chart1_Style}
                                                            cod={chart_plot.CODData}
                                                            max={null}
                                                            interval={null}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">Performance Ratio</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.PRx}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_pr}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.PRx}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_pr}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'PR'}
                                                            plotdata={chart_plot.PR}
                                                            plotcolor2="#E94646"
                                                            plotname2="PR Guarantee"
                                                            plotdata2={chart_plot.PRG}
                                                            chart_style={chart_plot.Chart2_Style}
                                                            cod={chart_plot.CODData}
                                                            max={120}
                                                            interval={20}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                </div>
                                                <div className={'tabs-content' + (dashboard_tabs === "operation" ? " " : " d-none")}>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">Operation Ratio</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.ORx}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_or}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.ORx}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_or}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'ORx'}
                                                            plotdata={chart_plot.ORx}
                                                            plotcolor2="#E94646"
                                                            plotname2="OR Guarantee"
                                                            plotdata2={chart_plot.ORG}
                                                            chart_style={chart_plot.Chart3_Style}
                                                            cod={chart_plot.CODData}
                                                            max={120}
                                                            interval={20}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">Energy Not Supply</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.ENS}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_ens}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.ENS}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_ens}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'ENS'}
                                                            plotdata={chart_plot.ENS}
                                                            chart_style={chart_plot.Chart4_Style}
                                                            cod={chart_plot.CODData}
                                                            max={null}
                                                            interval={null}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                </div>
                                                <div className={'tabs-content' + (dashboard_tabs === "co2" ? " " : " d-none")}>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">CO<sub>2</sub> Reduction</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.CO2}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_co2}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.CO2}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_co2}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'CO2'}
                                                            plotdata={chart_plot.CO2}
                                                            chart_style={chart_plot.Chart5_Style}
                                                            cod={chart_plot.CODData}
                                                            max={null}
                                                            interval={null}
                                                            co2factor={chart_plot.co2_factor}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">Estimate Saving</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.Saving}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_saving}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.Saving}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_saving}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'Saving'}
                                                            plotdata={chart_plot.Saving}
                                                            chart_style={chart_plot.Chart6_Style}
                                                            cod={chart_plot.CODData}
                                                            max={null}
                                                            interval={null}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                </div>
                                                <div className={'tabs-content' + (dashboard_tabs === "value" ? " " : " d-none")}>
                                                    <div className='chart-box'>
                                                        <h6 className="card-title font-weight-bold mb-0">Estimate Energy Value</h6>
                                                        <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='overall-chart-boxs' key={index}>
                                                                            <h6 className='factory-name'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</h6>
                                                                            <div className='overall-chart-subtable'>
                                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.Value}</div>
                                                                                <div className='overall-chart-cell cell-value'>{data.value_eval}</div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                            <div className='chart-box-table-row'>
                                                                <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                                <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.Value}</div>
                                                            </div>
                                                            {
                                                                chart_plot.chart_box.map((data, index) => (
                                                                    data.page === page_selected || data.page === 0 ?
                                                                        <div className='chart-box-table-row' key={index}>
                                                                            <div className='chart-box-table-cell'>
                                                                                <div className='chart-box-table-cell'>{!data.header.includes("Total") ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {!data.header.includes("Total") ? data.sitecode_text : null} {data.sitename_th}</div>
                                                                            </div>
                                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_eval}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                ))
                                                            }
                                                        </div>
                                                        <CanvasJSReact_ChartPerformance
                                                            xlabel={chart_plot.XLabel}
                                                            sum_time={chart_plot.sum_time}
                                                            sum_code={'Value'}
                                                            plotdata={chart_plot.Value}
                                                            chart_style={chart_plot.Chart7_Style}
                                                            cod={chart_plot.CODData}
                                                            max={null}
                                                            interval={null}
                                                            site_handle={site_handle}
                                                            plot_color={plot_color}
                                                            page_selected={page_selected}
                                                        ></CanvasJSReact_ChartPerformance>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </section >

    )
}
export default Business